import React, {useState} from "react";
import {observer} from "mobx-react";
import GeneralDialog from "./GeneralDialog";
import {useStores} from "../../Hooks";
import FormControl from "@mui/material/FormControl";
import {languageEnum} from "../../serverClientShared/sharedEnums";
import Utility from "../../Utility";
import {FrontlineCheckbox} from "../Shared/FrontlineCheckbox";
import Button from "@mui/material/Button";

const EditorLanguageModal = observer(() => {
    const {generalStore, procedureStore, modalStore} = useStores();
    const [copyOld, setCopyOld] = useState(false);
    const [selectedLanguagesToAdd, setSelectedLanguagesToAdd] = useState([]);
    const {processNewLanguage} = modalStore.modalData;

    const addLanguage = async (defaultLang, copyOld) => {
        await processNewLanguage(selectedLanguagesToAdd, defaultLang, copyOld, false);
    }


    const renderProcedureLanguageOptions = () => {
        return (
            <div className="default-language-options">

                <FormControl>
                        {
                            Object.keys(languageEnum)
                                .filter(language => !procedureStore.availableNodeLanguages.includes(language))
                                .map((language, i) => <div key={language}>{Utility.renderLanguageMenuOption(language, i + 1, procedureStore.currentProcedure.DefaultLanguage, true, true, {showSwitch: false, isAddLanguageFlow: true, openPopover: null, setOpenPopover: null, anchorElMorePopover: null, setAnchorElMorePopover: null, setShowConfirmDeletePopup: null, handleChangeDefaultLanguage: null,  selectedLanguagesToAdd, setSelectedLanguagesToAdd})}</div>)
                        }

                </FormControl>
            </div>
        );
    }

    const renderFooter  = () => {
        return (
            <span className='default-language-options'>
                <div className="copy-old-default-checkbox-container">
                    <FrontlineCheckbox
                        checked={copyOld}
                        className="copy-old-default-checkbox"
                        color="primary"
                        onChange={() => setCopyOld(!copyOld)}
                    />
                    <div className="copy-old-default-checkbox-label">
                        {`${generalStore.translate('copyTextFromCurrentDefaultLanguageToLanguagesSelected')}`}
                    </div>
                 </div>
                <div className='buttons-add-languages'>
                    <Button
                        onClick={()=>
                            modalStore.isEditorLanguageModalOpen=false
                    }
                        variant="contained"
                        className='cancel-add-language-button'>
                        {generalStore.translate('cancel')}
                    </Button>

                    <Button
                        disabled={selectedLanguagesToAdd.length === 0}
                        onClick={async ()=>{
                            await addLanguage(selectedLanguagesToAdd, copyOld);
                            setSelectedLanguagesToAdd([]);
                            modalStore.isEditorLanguageModalOpen=false;
                        }}
                        variant="contained"
                        className='add-language-button'>
                        {generalStore.translate('add')}
                    </Button>
                </div>
            </span>
        );
    }

    return (
        <GeneralDialog
            openControl='isEditorLanguageModalOpen'
            className='procedure-option-dialog'
            onEnter={null}
            title={generalStore.translate('addLanguages')}
            body={renderProcedureLanguageOptions()}
            isConfirmDisabled={true}
            onConfirm={null}
            dialogFooter = {renderFooter()}
        />
    );
})

export default EditorLanguageModal;
